import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-static-container',
  templateUrl: './static-container.component.html',
  styleUrls: ['./static-container.component.scss'],
  standalone: false
})
export class StaticContainerComponent {
  @Input()
  headerImage: string;

  @Input()
  capsuleConseilTitre: string;

  @Input()
  capsuleConseilTexte: string;

  @Input()
  capsuleAvecInfoBulle: any;

  @Input()
  disableReturnButton: boolean;

  @Input() isLinesGreaterThan4 = false;
  constructor(private readonly _router: Router) {
    this.headerImage = '';
    this.disableReturnButton = false;
  }

  navigateTo(target: string): void {
    this._router.navigateByUrl(target);
  }

  get hasCapsuleConseil() {
    return !!this.capsuleConseilTexte || this.capsuleAvecInfoBulle;
  }
}
